import { Pen } from '@meta2d/core';
import { reactive } from 'vue';

export enum SelectionMode {
  File,
  Pen,
  Pens
}

const selections = reactive<{
  mode: SelectionMode;
  pen?: Pen;
  pens?:Pen[];
}>({
  // 选中对象类型：0 - 画布；1 - 单个图元
  mode: SelectionMode.File,
  pen: undefined,
  pens:[]
});

export const useSelection = () => {
  const select = (pens?: Pen[]) => {
    if(pens){
      if(pens.length==1){
          selections.mode = SelectionMode.Pen;
          selections.pen = pens[0];
      }else{
          selections.mode = SelectionMode.Pens;
          selections.pens = pens;
      }
    }else{
      selections.mode = SelectionMode.File;
      selections.pen = undefined;
      selections.pens = [];
      return
    }
  };
  return {
    selections,
    select,
  };
};
